module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_c('a', {
    attrs: {
      "id": "HLD7"
    }
  }), _vm._v("Donut Shop")]), _vm._v(" "), _c('p', {
    staticClass: "mhead"
  }, [_vm._v("Fabric Requirements and Cutting")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg13b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ph1"
  }, [_vm._v("Make the Block")]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("Sew the Inner Ring")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Sew piece B to the bottom of piece A.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Sew piece C to the right side of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Sew piece D to the top of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Sew piece E to the left side of the block. "), _c('i', [_vm._v("figure a")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("Add the Background Ring")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Sew piece F to the bottom of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Sew piece G to the right side of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Sew piece H to the top of the block.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Sew piece I to the left side of the block. "), _c('i', [_vm._v("figure b")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ph2"
  }, [_vm._v("ALTERNATE IDEAS")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14d.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg14c.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efc9364","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_chapter05.vue
// module id = 78
// module chunks = 0